import React from 'react';
import './BehavioralPatternShape.scss';
import { BAFactorShapeType, BehavioralPatternGraphType, behavioralPatternGraphs } from './FactorShape.service';

type Props = {
  graphType: BehavioralPatternGraphType;
  shapeType: BAFactorShapeType;
  /**
   * The coordinates for the shape. If provided, the shape is assumed to be
   * inside an SVG. If not provided, the shape will be returned within an SVG.
   */
  coords?: {
    x: number;
    y: number;
  };
};

/**
 * A shape which is used in a behavioral pattern bar. This can also be used
 * outside a graph by not providing the coordinates.
 */
const BehavioralPatternShape = ({ graphType, shapeType, coords }: Props): React.JSX.Element => {
  const baseClassName = 'BehavioralPatternShape';
  const graphInfo = behavioralPatternGraphs[graphType];

  // Shapes
  function getSvgShape() {
    switch (shapeType) {
      case BAFactorShapeType.Circle:
        return (
          <circle
            cx={coords?.x ?? graphInfo.circleRadius}
            cy={coords?.y ?? graphInfo.circleRadius}
            r={graphInfo.circleRadius}
            className={`${baseClassName}__circle`}
          />
        );
      case BAFactorShapeType.Square:
        return (
          <rect
            x={coords?.x}
            y={coords?.y}
            width={graphInfo.squareWidth}
            height={graphInfo.squareWidth}
            className={`${baseClassName}__square`}
          />
        );
    }
  }
  let shape = <g>{getSvgShape()}</g>;

  if (!coords) {
    const shapeWidth = shapeType === BAFactorShapeType.Circle ? graphInfo.circleRadius * 2 : graphInfo.squareWidth;
    shape = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${shapeWidth} ${shapeWidth}`}
        style={{ height: shapeWidth, width: shapeWidth, minWidth: shapeWidth, minHeight: shapeWidth }}
      >
        {shape}
      </svg>
    );
  }

  return shape;
};

export default BehavioralPatternShape;
